const MyBids = () => import("./views/my-bids.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/my_bids",
      component: MyBids,
      name: "Bid",
      meta: {
        groupName: "Private Sale",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
